export default __webpack_public_path__ + "static/media/harris-logo.7e65a6c0.png";